import { useState } from "react";
import { Minus, Plus, CheckCircle2 } from "lucide-react";

const MENU = [
  { id: "plov", name: "Plov", price: 9 },
  { id: "doner", name: "Dönər", price: 5 },
  { id: "salad", name: "Çoban salatı", price: 4 },
  { id: "lemon", name: "Limonad", price: 3 },
];

export const OrderDemo = () => {
  const [cart, setCart] = useState({});
  const [done, setDone] = useState(false);
  const total = MENU.reduce((s, m) => s + (cart[m.id] || 0) * m.price, 0);
  const add = (id, d) => setCart((c) => ({ ...c, [id]: Math.max(0, (c[id] || 0) + d) }));

  if (done)
    return (
      <div className="text-center py-6" data-testid="order-demo-success">
        <CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto" />
        <div className="font-display text-lg font-semibold mt-3">Demo sifariş qəbul edildi</div>
        <p className="text-sm text-[#a9a398] mt-1">Siz sifariş haqqında dərhal bildiriş alırsınız.</p>
        <button className="adv-btn-ghost mt-4 text-sm" onClick={() => { setDone(false); setCart({}); }} data-testid="order-demo-reset">Yenidən sına</button>
      </div>
    );

  return (
    <div data-testid="order-demo">
      <div className="space-y-2">
        {MENU.map((m) => (
          <div key={m.id} className="flex items-center justify-between rounded-xl bg-white/[0.03] border border-white/[0.06] p-3">
            <div>
              <div className="font-medium">{m.name}</div>
              <div className="text-xs text-[#a9a398] font-mono">{m.price} ₼ (nümunə)</div>
            </div>
            <div className="flex items-center gap-3">
              <button className="h-8 w-8 rounded-full bg-white/5 grid place-items-center" onClick={() => add(m.id, -1)} data-testid={`order-minus-${m.id}`}><Minus className="h-4 w-4" /></button>
              <span className="w-4 text-center font-mono" data-testid={`order-qty-${m.id}`}>{cart[m.id] || 0}</span>
              <button className="h-8 w-8 rounded-full bg-[#D6AD62] text-[#111110] grid place-items-center" onClick={() => add(m.id, 1)} data-testid={`order-plus-${m.id}`}><Plus className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
      <button className="adv-btn w-full mt-4" disabled={!total} onClick={() => setDone(true)} data-testid="order-demo-submit">
        Sifariş ver · <span className="font-mono">{total} ₼</span>
      </button>
    </div>
  );
};
